<template>
  <div class="upload d-flex flex-column">
    <div style="flex: 1;">
      <div v-if="status == 'error'">
        <div class="alert alert-danger">
          {{ errorMessage }}
        </div>
      </div>
      <div v-else class="row" style="height: 100%; min-height: 245px;">
        <div class="col-md-8">
          <div>
            <ul class="nav nav-tabs" style="margin-left: -8px;">
              <li class="nav-item">
                <a v-bind:class="{'nav-link': true, 'active': (tab == 'original'), 'text-danger': originalErrorCode}" href="#" @click.prevent="tab = 'original'" ondragstart="return false;">
                  <span :class="{'x-animate': true, 'x-active': tabOriginalLoading}"><i :class="`fas fa-circle-notch ${tabOriginalLoading ? 'fa-spin' : ''}`"></i></span><!--
                  --><i class="fas fa-exclamation-circle" v-if="originalErrorCode"></i><!--
                  -->{{ t.original }}
                </a>
              </li>
              <li class="nav-item">
                <a v-bind:class="{'nav-link': true, 'active': (tab == 'result'), 'disabled': !tabResultAvailable, 'text-danger': resultErrorCode}" href="#" @click.prevent="tab = 'result'" ondragstart="return false;">
                  <span :class="{'x-animate': true, 'x-active': tabResultLoading}"><i :class="`fas fa-circle-notch ${tabResultLoading ? 'fa-spin' : ''}`"></i></span><!--
                  --><i class="fas fa-exclamation-circle" v-if="resultErrorCode"></i><!--
                  -->{{ t.removed_background }}
                </a>
              </li>
            </ul>
          </div>
          <div class="upload-tabs">
            <div v-bind:class="{'active': (tab == 'original')}" class="upload-tab justify-content-center">
              <div class="d-inline-flex img-wrapper" :style="`background: #dddfe1; max-width: 100%; align-items: center; justify-content: center; flex-direction: column;${!originalUrl ? 'min-width: 100%; min-height: 260px;' : ''}`">
                <div v-if="status == 'queued' || status == 'token_requested' || status == 'captcha_required' || status == 'uploading'" class="progress-details">
                  <div class="h3 text-center mb-3" style="opacity: 0.7;" v-if="status == 'queued'">{{ t.waiting_for_previous_images }}</div>
                  <div class="h3 text-center mb-3" style="opacity: 0.7;" v-if="status == 'token_requested'">{{ t.preparing_upload }}</div>
                  <div class="h3 text-center mb-3" style="opacity: 0.7;" v-if="status == 'uploading'">{{ t.uploading }}</div>
                  <div v-if="status == 'captcha_required'" class="card">
                    <div class="card-body">
                      <checkbox-captcha v-on:completed="completeCaptcha($event)" v-bind="captchaConfig || {}" />

                      <div v-if="canSkipCaptcha">
                        <div>
                          <a href="#" class="skip-btn" v-on:click.prevent="completeCaptcha('skip')">
                            {{ t.skip }}
                          </a>
                          {{ t.for_025_credits }}
                        </div>

                        <div>
                          <span style="font-size: 80%;">{{ t.current_balance }}: {{ creditBalance }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="progress" v-if="status == 'uploading'">
                    <div class="progress-bar" role="progressbar" v-bind:aria-valuenow="uploadProgressPercent" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: `${uploadProgressPercent}%`}"></div>
                  </div>
                  <div v-if="uploadingNote" style="font-size: 90%; opacity: 0.5;">
                    {{ uploadingNote }}
                  </div>
                </div>
                <div class="alert alert-danger mb-0" v-if="originalErrorCode">
                  <strong>{{ remote.original.error_message }}</strong>
                </div>
                <div style="position: absolute; z-index: 10; top: 0; left: 0; right: 0; bottom: 0;" v-if="status == 'uploading' || status == 'processing'">
                  <div class="ph-item" style="border: 0; padding: 0; margin: 0; width: 100%; height: 100%; background: transparent;">
                    <div class="ph-picture" style="height: 100%; background: transparent;"></div>
                  </div>
                </div>
                <span>
                  <img v-bind:src="originalUrl" class="img-fluid" style="max-height: 50vh;" ondragstart="return false;" data-hj-suppress="true" />
                </span>
              </div>
            </div>
            <div v-bind:class="{'active': (tab == 'result')}" class="upload-tab upload-tab-second justify-content-center">
              <div class="img-wrapper" v-if="resultUrl">
                <a :href="resultUrl" target="_blank" rel="noopener" @click="mobileAppDownload">
                  <img v-bind:src="resultUrl" style="max-height: 50vh;" class="img-fluid transparency-grid" ondragstart="return false;" data-hj-suppress="true" />
                </a>
                <div class="btn-group" style="position: absolute; right: 10px; top: 10px; z-index: 20;">
                  <button type="button" class="btn btn-outline-secondary btn-sm edit-btn edit-btn-main" @click="showEditor">
                    <i class="fas fa-paint-brush"></i>
                    {{ t.edit }}
                  </button>
                  <button type="button" class="btn btn-secondary btn-sm dropdown-toggle dropdown-toggle-split edit-btn edit-btn-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="remote.full && deviceSupportsFullImages">
                    <span class="sr-only">{{ t.toggle_dropdown }}</span>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right py-1" style="min-width: 5rem;" v-if="remote.full && deviceSupportsFullImages">
                    <a class="dropdown-item small px-2" href="#" @click.prevent="showEditor">{{ t.preview }}</a>
                    <a class="dropdown-item small px-2" href="#" @click.prevent="showDownloadDialog('edit')">{{ t.high_res }}</a>
                  </div>
                </div>
              </div>

              <div v-if="resultErrorCode">
                <div v-if="resultErrorCode == 'no_foreground_found'">
                  <h2 class="text-muted">
                    {{ t.sorry }}
                  </h2>
                  <p class="lead text-danger">
                    <span style="display: inline-block; margin: 0 10px;"><i class="fas fa-times"></i> {{ t.could_not_identify_foreground }}</span>
                  </p>
                  <div class="alert" style="border-color: #cbcbcb; background: rgba(0,0,0,0.03);">
                    <p>
                      {{ t.please_select_supported_foreground }}
                    </p>
                    <div>
                      <a target="_blank" :href="localizedUrl('/sample_images')">
                        <i class="fas fa-images"></i>
                        {{ t.example_gallery }}
                      </a>
                    </div>
                    <div>
                      <a target="_blank" :href="localizedUrl('/help/a/what-images-are-supported')">
                        <i class="fas fa-hand-point-right"></i> {{ t.photo_recommendations }}
                      </a>
                    </div>
                  </div>
                  <p style="font-size: 85%; margin-bottom: 10px;">
                    <strong>{{ t.constantly_improving }}</strong> {{ t.want_to_help }}
                  </p>
                  <div class="small" data-controller="feedback" :data-feedback-url="`/images/${this.remote.id}`">
                    <div data-target="feedback.contributeUnsupportedBtn">
                      <span style="display: inline-block; margin-right: 5px;">{{ t.help_us_improve }}:</span>
                      <a href="#" class="btn btn-outline-primary" data-action="click->feedback#contributeUnsupported" style="padding: 5px 15px; font-size: 90%;">{{ t.contribute_image }}</a>
                    </div>

                    <div data-target="feedback.contributeUnsupportedThanksBar" style="display: none;">
                      {{ t.thanks_for_feedback }}
                    </div>
                  </div>
                </div>
                <div v-else class="alert alert-danger mb-0">
                  <strong>{{ remote.result.error_message }}</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center text-center pt-2">
            <div v-if="resultUrl && remote.result.rated === false">
              <div data-controller="feedback" :data-feedback-url="`/images/${remote.id}`" class="feedback-form">
                <div class="small d-flex flex-row flex-nowrap align-items-center justify-content-center" data-target="feedback.inputBar">
                  <span class="mr-1">{{ t.rate_this_result }}:</span>

                  <div class="d-flex">
                    <a class="btn btn-sm" :title="t.rate_good" data-action="click->feedback#rateGood" href="#" ondragstart="return false;"><i class="fal fa-smile fa-2x"></i></a>
                    <a class="btn btn-sm" :title="t.rate_bad" data-action="click->feedback#rateBad" href="#" ondragstart="return false;"><i class="fal fa-frown fa-2x"></i></a>
                  </div>
                </div>

                <div class="small" data-target="feedback.shareBar" style="display: none;">
                  <span style="display: inline-block; margin-right: 5px;">{{ t.spread_the_word }}:</span>
                  <div class="d-inline-block">
                    <a target="_blank" class="btn btn-outline-twitter btn-sm" :href="twitterShareUrl(t.tweet_message)" ondragstart="return false;">
                      <i class="fab fa-twitter fa-fw"></i>
                      {{ t.tweet }}
                    </a>
                    <a class="btn btn-outline-facebook btn-sm" :href="facebookShareUrl()" target="_blank" ondragstart="return false;">
                      <i class="fab fa-facebook-f fa-fw"></i>
                      {{ t.share }}
                    </a>
                  </div>
                </div>

                <div class="small" data-target="feedback.thanksBar" style="display: none;">
                  {{ t.thanks_for_feedback }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 py-md-3 d-flex flex-column align-items-center justify-content-center text-center fade-in-on-render">
          <div class="d-flex flex-grow-1 flex-shrink-1 flex-column align-items-center justify-content-center download-buttons">
            <div class="d-flex flex-row flex-md-column right-column">
              <div class="my-3 w-100">
                <div class="mb-1">
                  <a v-if="resultUrl" :href="resultUrl" target="_blank" rel="noopener" class="btn btn-primary btn-download mr-2 mr-md-0" @click="mobileAppDownload" ondragstart="return false;">{{ t.download }}</a>
                  <div v-else-if="status != 'finished'" class="ph-item border-0 p-0 m-0">
                  <!-- <div v-else class="ph-item border-0 p-0 m-0"> -->
                    <div class="ph-row m-0">
                      <div class="center-block ph-button"></div>
                    </div>
                  </div>
                </div>
                <div class="text-muted small">
                  <div v-if="resultUrl">
                    <span class="d-block d-md-inline">{{ t.preview_image }}</span>
                    <div class="d-block d-md-inline">
                      {{ remote.result.width }} &times; {{ remote.result.height }}
                      <span class="hover-tooltip" :data-tippy-content="`<strong>${t.good_quality}</strong><br/>${t.up_to_025_megapixels}`" data-tippy-placement="bottom">
                        <i class="fas fa-info-circle"></i>
                      </span>
                    </div>
                  </div>
                  <div v-else-if="status != 'finished'" class="ph-item border-0 p-0 m-0">
                    <div class="ph-row m-0">
                      <div class="center-block ph-info"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3 mt-3 mt-md-0 w-100" v-if="deviceSupportsFullImages">
                <div class="mb-1">
                  <button v-if="resultUrl" :class="`btn btn-download ml-2 ml-md-0 btn-outline-${remote.full ? 'primary' : 'secondary'}`" :disabled="!remote.full" :style="`${remote.full ? '' : 'opacity: 0.4;'}`" @click="showDownloadDialog('download')">{{ t.download_high_res }}</button>
                  <div v-else-if="status != 'finished'" class="ph-item border-0 p-0 m-0">
                  <!-- <div v-else class="ph-item border-0 p-0 m-0"> -->
                    <div class="ph-row m-0">
                      <div class="center-block ph-button"></div>
                    </div>
                  </div>
                </div>
                <div class="text-muted small">
                  <div v-if="resultUrl">
                    <span class="d-block d-md-inline">{{ t.full_image }}</span>
                    <div class="d-block d-md-inline" v-if="remote.full">
                      {{ remote.full.width }} &times; {{ remote.full.height }}
                      <span class="hover-tooltip" :data-tippy-content="`<strong>${t.best_quality}</strong><br/>${t.up_to_25_megapixels}`" data-tippy-placement="bottom">
                        <i class="fas fa-info-circle"></i>
                      </span>
                    </div>
                    <span v-else>
                      {{ t.not_available }}
                      <span class="hover-tooltip" :data-tippy-content="t.please_upload_higher_resolution" data-tippy-placement="bottom">
                        <i class="fas fa-info-circle"></i>
                      </span>
                    </span>
                  </div>
                  <div v-else-if="status != 'finished'" class="ph-item border-0 p-0 m-0">
                    <div class="ph-row m-0">
                      <div class="center-block ph-info"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="originalUrl && resultUrl && !mobileApp"> <!--  && designifyCtaVariant -->
              <designify-cta :image="resultUrl" :originalImage="originalUrl" :imageType="ctaImageType" :t="t" :remoteId="remote.id"></designify-cta>
            </div>
            <div v-if="resultUrl">
             <canva-cta-post v-if="canvaCtaVariant == 'post'" :image="resultUrl" :variant="canvaCtaVariant"></canva-cta-post>
             <canva-cta-pre v-if="canvaCtaVariant == 'pre'" :image="resultUrl" :variant="canvaCtaVariant"></canva-cta-pre>
            </div>
          </div>

        </div>
      </div>

      <a class="btn image-result--delete-btn" v-bind:disabled="deleting" :title="t.delete_image" href="#" v-on:click.prevent="deleteUpload" v-if="status == 'finished' || status == 'error'" ondragstart="return false;">×</a>
    </div>
  </div>
</template>

<script>
import Upload from './upload';
import CheckboxCaptcha from './checkbox_captcha';
import EditorUI from '../src/editor/editor_ui';
import DesignifyCta from './designify_cta';
import CanvaCtaPost from './canva_cta_post';
import CanvaCtaPre from './canva_cta_pre';
import EventBus from "../src/event_bus"

import tippy from 'tippy.js';

export default {
  props: {
    status: String,
    errorMessage: String,
    uploadProgress: Number,
    remote: Object,
    captchaConfig: Object,
    canSkipCaptcha: Boolean,
    creditBalance: String,
    onCaptchaCompleted: Function,
    uploadingNote: String,
    t: Object,
    openFullImageDialog: Boolean,
  },
  components: { Upload, CheckboxCaptcha, CanvaCtaPost, CanvaCtaPre, DesignifyCta },
  data() {
    return {
      tab: this.remote.result ? 'result' : 'original',
      deviceSupportsFullImages: (!window.mobile_app || this.t.mobile_app_supports_login),
      deleting: false,
      canvaCtaVariant: "control",
    };
  },
  watch: {
    remote: function(newRemote, oldRemote) {
      if(!oldRemote.result && newRemote.result) {
        this.tab = 'result';
      }
    }
  },
  mounted() {
    this.updateTooltips();
    if(this.openFullImageDialog) {
      this.showDownloadDialog('download');
    }
    this.canvaCtaVariant = $(`meta[property='split:canva_cta_experiment']`).attr("content")
  },
  updated() {
    this.updateTooltips();
  },
  computed: {
    mobileApp() {
      return window.mobile_app;
    },
    ctaImageType() {
      if (this.imageType=='car') return 'car';
      if (this.imageType=='person' || this.imageType=='animal') return 'person_animal';
      return 'other';
    },
    uploadProgressPercent() {
      return Math.round(this.uploadProgress * 100);
    },
    tabResultAvailable() {
      return this.status == 'finished' && this.remote.result;
    },
    tabOriginalLoading() {
      return this.status == 'token_requested' || this.status == 'uploading' || (this.status == 'processing' && !this.remote.original);
    },
    tabResultLoading() {
      return this.status == 'processing' && this.remote.original;
    },
    originalErrorCode() {
      if(this.remote.original) return this.remote.original.error_code;
      else return null;
    },
    resultErrorCode() {
      if(this.remote.result) return this.remote.result.error_code;
      else return null;
    },
    originalUrl() {
      if(this.remote.original) return this.remote.original.url;
      else return null;
    },
    resultUrl() {
      if(this.remote.result) return this.remote.result.url;
      else return null;
    },
    imageType() {
      if (this.remote.result) return this.remote.result.foreground_type;
      else return null;
    }
  },
  methods: {
    localizedUrl(url) {
      if(this.t.current_locale == "en") {
        return url;
      } else {
        return `/${this.t.current_locale}${url}`;
      }
    },
    twitterShareUrl(text) {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text + ' ')}&via=remove_bg `;
    },
    facebookShareUrl() {
      var url = "https://www.remove.bg/";
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    },
    mobileAppDownload(event) {
      window.track("Images", "download_result_small", "Download image result (small)");
      if(window.hj) {
        if(this.remote.result.foreground_type == "car") {
          window.hj("trigger", "download_car_result_small");
        } else {
          window.hj("trigger", "download_result_small_other");
        }
      }
      EventBus.$emit("preview-download-started")
      if(!window.mobile_app) return;
      event.preventDefault();
      window.mobile_app.downloadUrl(this.remote.result.filename, this.resultUrl);
    },
    showDownloadDialog(target='download') {
      $.magnificPopup.open({
        items: {
          src: `${this.remote.full.url}?target=${target}`
        },
        type: 'ajax'
      });

      $.magnificPopup.instance._onFocusIn = function() {
        return true
      }
    },
    showEditor() {
      EditorUI.show({
        "foreground-url": this.resultUrl,
        "original-url": this.originalUrl,
        "filename": this.remote.result.filename,
        "foregroundType": this.remote.result.foreground_type,
        "locale": document.documentElement.lang,
      });
    },
    updateTooltips() {
      this.$nextTick(() => {
        var tooltips = $(this.$el).find(".hover-tooltip");
        if(tooltips.length > 0) {
          tippy(tooltips.get());
        }
      })
    },
    deleteUpload() {
      if(this.status == 'finished') {
        this.deleting = true;
        $.ajax({
          type: 'DELETE',
          url: this.remote.url,
          success: (data) => {
            this.$emit("delete", { key: this.$vnode.key });
          },
          error: (xhr) => {
            if(xhr.status == 404) {
              this.$emit("delete", { key: this.$vnode.key });
            }
            else {
              this.deleting = false;
              alert(this.t.failed_to_delete_image)
            }
          }
        })
      }
      else {
        this.$emit("delete", { key: this.$vnode.key });
      }
    },
    completeCaptcha(value) {
      this.onCaptchaCompleted({
        value: value,
        version: 'v2_checkbox',
      })
    },
    report() {
      reportSplit("designify_footer_cta_round_3", null, false)
    },
  },
}
</script>

<style lang="scss" scoped>
.upload {
  background: #fff;

  padding: 15px 15px;
  margin-top: 20px;
  margin-bottom: 20px;

  box-shadow: 0px 0px 3px #00000029;
  border-radius: 2px;
  position: relative;

  min-height: 300px;

  max-width: 990px;
  margin-left: auto;
  margin-right: auto;
}

.right-column {
  width: 100%;

   @media(min-width: 768px) {
     width: 200px;
   }
}

.download-buttons {
  @media(max-width: 767px) {
    width: 100%;

    div {
      width: 100%;
    }
  }
}
.btn-download {
  width: 100%;

  @media(min-width: 768px) {
    min-width: 190px;
  }
}

.ph-button {
  height: 40px;
  width: 100%;

  @media(min-width: 768px) {
    width: 190px;
  }
}

.ph-info {
  height: 19px;
  width: 100%;

  @media(min-width: 768px) {
    width: 190px;
  }
}

@media(min-width: 576px) {
  .upload {
    padding: 20px 30px;
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
.upload-footer {
  margin-left: -15px;
  margin-right: -15px;
  margin-bottom: -20px;
  background: #eaedef;
  padding-top: 7px;
  padding-bottom: 8px;
  padding-left: 15px;
  padding-right: 15px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
  line-height: 1;
}
@media(min-width: 576px) {
  .upload-footer {
    margin-left: -30px;
    margin-right: -30px;
    padding-left: 30px;
    padding-right: 30px;
  }
}
.image-result--delete-btn {
  position: absolute;
  right: 6px;
  top: 8px;
  font-size: 36px;
  color: #ccc;
  z-index: 500;
  padding: 0;
  line-height: 1;
  width: 35px;
  height: 34px;
  margin: 0;
}
.image-result--delete-btn[disabled] {
  pointer-events: none;
}

@keyframes pulse {
  25% {opacity: 1.0;}
  50% {opacity: 0.5;}
  75% {opacity: 1.0;}
}

.with-pulse {
  -webkit-animation-name: pulse; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 1000ms; /* Safari 4.0 - 8.0 */
  animation-name: pulse;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}
.progress {
  height: 32px;
  border-radius: 5px;
}
.progress .progress-bar {
  background: #727374;
}
.upload-tabs {
  margin-top: 10px;
  display: flex;
  flex-flow: row nowrap;
}
.upload-tab {
  width: 100%;
  flex: none;
  opacity: 0;
  display: none;
  position: relative;
}
.upload-tab.active {
  display: flex;
  opacity: 1;
  -moz-animation: tabShow 300ms;
  -webkit-animation: tabShow 300ms;
  -o-animation: tabShow 300ms;
  animation: tabShow 300ms;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
@keyframes tabShow {
    0% {
        display: none;
        opacity: 0;
    }
    1% {
        display: block;
        opacity: 0;
    }
    100% {
        display: block;
        opacity: 1;
    }
}
@-webkit-keyframes tabShow {
    0% {
        display: none;
        opacity: 0;
    }
    1% {
        display: block;
        opacity: 0;
    }
    100% {
        display: block;
        opacity: 1;
    }
}

.progress-details {
  max-width: 100%;
  opacity: 0;
  -moz-animation: showDelayed 2s;
  -webkit-animation: showDelayed 2s;
  -o-animation: showDelayed 2s;
  animation: showDelayed 2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
@keyframes showDelayed {
    85% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
@-webkit-keyframes showDelayed {
    85% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.fade-in-on-render {
  opacity: 0;
  -moz-animation: fadeInOnRender 300ms;
  -webkit-animation: fadeInOnRender 300ms;
  -o-animation: fadeInOnRender 300ms;
  animation: fadeInOnRender 300ms;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
@keyframes fadeInOnRender {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
@-webkit-keyframes fadeInOnRender {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.x-animate {
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  width: 0;
  position: relative;
  top: -2px;
  overflow: hidden;
  transition: width 300ms;
}

.x-animate.x-active {
  width: 20px;
}

.edit-btn {
  font-size: 0.8rem;
  padding: 0.15rem 0.4rem;
  transition: opacity 300ms;
}

.img-wrapper .edit-btn {
  opacity: 0.6;
}
.img-wrapper:hover .edit-btn {
  opacity: 1.0;
}

.edit-btn-main {
  background: #edeff0;
}
.edit-btn-main:hover {
  background: #53616b;
  color: #fff;
}
.edit-btn-dropdown {
  font-size: 1rem;
  padding: 0 5px;
}
</style>
